import {
  VlogPlaylistCard,
  VlogSectionHeading,
  VlogVideoCard,
} from "@modules/study/common/vlog";
import { Grid, Pagination } from "@mui/material";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { Fragment, useEffect, useState } from "react";
import styles from "./single_vlog_category.module.scss";

const links = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Vlog",
    link: "/vlog",
  },
  {
    title: "Category",
    link: "/vlog/category",
  },
];

export const SingleVlogCategory = ({ vlogCategories }) => {
  const router = useRouter();

  const { slug } = router.query;

  const [paginate, setPaginate] = useState({
    currentPage: vlogCategories.currentPage,
    limit: vlogCategories.limit,
    page_total: vlogCategories.page_total,
    total: vlogCategories.total,
  });

  useEffect(() => {
    if (vlogCategories.currentPage) {
      setPaginate((prev) => ({
        ...prev,
        currentPage: vlogCategories.currentPage,
      }));
    }
  }, [vlogCategories.currentPage]);

  const paginationHandler = (e, page) => {
    e.preventDefault();
    router.push(`/vlog/category/${slug}?limit=20&page=${page}`);
  };
  return (
    <Fragment>
      <VlogSectionHeading
        links={links}
        title={vlogCategories?.searchHead?.title}
      />
      <section>
        <div className="container">
          <Grid container spacing={4}>
            {vlogCategories &&
              vlogCategories?.results?.length > 0 &&
              vlogCategories?.results?.map((item, i) => (
                <Grid item md={3} sm={12} xs={12} key={i}>
                  <VlogVideoCard item={item} />
                </Grid>
              ))}
          </Grid>
          {paginate && paginate.total > paginate.limit && (
            <PaginationComponent
              paginate={paginate}
              paginationHandler={paginationHandler}
            />
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default SingleVlogCategory;
